import axios from 'axios'
// import store from '../store'
// import router from '../router/index.js'
import { PY_WEB_UPDATE_TIMESTAMP, WEB_DICTIONARY_UPDATE_TIMESTAMP, WEB_USER_TOKEN, WEB_DEVICE_ID } from '../constants/local_storage_key'
import { USER_TOKEN_HEADER_NAME, DEVICE_ID_HEADER_NAME, PLATFORM_HEADER_NAME, DEVICE_MODEL_HEADER_NAME, APP_VERSION_HEADER_NAME, WEB_UPDATE_TIMESTAMP } from '../constants/http_params'
import { Toast } from 'mint-ui'
// import ajax from './ajax'
import qs from 'qs'
let webUpdateTimestamp = 0
let dictionaryUpdateTimestamp = 0
axios.defaults.timeout = 300000
axios.globalToken = null
axios.globalDeviceId = getDeviceId()
function getDeviceId() {
  let deviceId = localStorage.getItem(WEB_DEVICE_ID)
  if (!deviceId) {
    deviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0
      let v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
    localStorage.setItem(WEB_DEVICE_ID, deviceId)
  }
  return deviceId
}

axios.setTokenAndDeviceId = function (token, deviceId) {
  localStorage.setItem(WEB_DEVICE_ID, deviceId)
  sessionStorage.setItem(WEB_USER_TOKEN, token)
  axios.globalDeviceId = deviceId
  axios.globalToken = token
}

/* 发送请求前，将userToken添加到参数中 */
axios.interceptors.request.use(
  function (config) {
    /* 在header中设置token */
    let deviceModel = 'pc'
    let platform = 'windows'
    let appVersionName = 'pc'
    // let deviceModel = 'web'
    // let platform = 'web'
    // let appVersionName = 'web'
    if (!axios.globalToken) {
      axios.globalToken = sessionStorage.getItem(WEB_USER_TOKEN)
    }
    if (axios.globalToken) {
      config.headers[USER_TOKEN_HEADER_NAME] = axios.globalToken
      config.headers[DEVICE_MODEL_HEADER_NAME] = deviceModel
      config.headers[PLATFORM_HEADER_NAME] = platform
    }
    config.headers[DEVICE_ID_HEADER_NAME] = axios.globalDeviceId
    webUpdateTimestamp = localStorage.getItem(PY_WEB_UPDATE_TIMESTAMP)
    config.headers[WEB_UPDATE_TIMESTAMP] = webUpdateTimestamp
    config.headers[APP_VERSION_HEADER_NAME] = appVersionName
    if (config.method === 'get') {
      // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    console.log('axios request-------', config)
    return config
  },
  function (error) {
    console.log(error)
    Toast({
      message: '网络超时',
      position: 'bottom'
    })
  }
)

axios.interceptors.response.use(
  function (response) {
    if (response.data) {
      if (response.data.webUpdateTimestamp && response.data.webUpdateTimestamp > 0) {
        webUpdateTimestamp = localStorage.getItem(PY_WEB_UPDATE_TIMESTAMP)
        if (webUpdateTimestamp) {
          webUpdateTimestamp = parseInt(webUpdateTimestamp)
        }
        if (webUpdateTimestamp > 0 && response.data.webUpdateTimestamp > webUpdateTimestamp) {
          webUpdateTimestamp = response.data.webUpdateTimestamp
          localStorage.setItem(PY_WEB_UPDATE_TIMESTAMP, webUpdateTimestamp)
          if (window.plugins && window.plugins.Reload) {
            window.plugins.Reload.reload()
          }
        } else {
          webUpdateTimestamp = response.data.webUpdateTimestamp
          localStorage.setItem(PY_WEB_UPDATE_TIMESTAMP, webUpdateTimestamp)
        }
      }
      if (response.data.dictionaryUpdateTimestamp && response.data.dictionaryUpdateTimestamp > 0) {
        dictionaryUpdateTimestamp = localStorage.getItem(WEB_DICTIONARY_UPDATE_TIMESTAMP)
        if (dictionaryUpdateTimestamp) {
          dictionaryUpdateTimestamp = parseInt(dictionaryUpdateTimestamp)
        }
        if (dictionaryUpdateTimestamp > 0 && response.data.dictionaryUpdateTimestamp > dictionaryUpdateTimestamp) {
          dictionaryUpdateTimestamp = response.data.dictionaryUpdateTimestamp
          localStorage.setItem(WEB_DICTIONARY_UPDATE_TIMESTAMP, dictionaryUpdateTimestamp)
          // ajax.synGet('/api/dicts/queryAll', (response) => {
          //   console.log('--- fresh dictionary list ---')
          //   globalVue.$store.commit('dictionary/setDictionaries', response)
          // })
        } else {
          dictionaryUpdateTimestamp = response.data.dictionaryUpdateTimestamp
          localStorage.setItem(WEB_DICTIONARY_UPDATE_TIMESTAMP, dictionaryUpdateTimestamp)
        }
      }
      if (response.data.errorCode) {
        if (response.data.errorCode === 401) { //  未登录，跳转到登录页面
          axios.globalToken = null
          axios.globalDeviceId = getDeviceId()
        }
      }
    }
    console.log('axios response-------', response)
    return response
  },
  function (error) {
    console.log(error)
    Toast({
      message: '网络超时',
      position: 'bottom'
    })
  }
)
export default axios



// WEBPACK FOOTER //
// ./src/apis/index.js